import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a56313a946694dbccd7bd5340d78e8a9fb from "./generated-110afd0b-da65-4635-baf0-a87f7023a382.json";

import a6528001b924c31c956890512d64f739fb from "./generated-54540bf7-2099-4716-a4ce-7406fa57068f.json";

import a4fe25190375de7813e516f4819fb890eb from "./generated-2841e5d0-7c6d-4405-8155-f60054c8a533.json";

import af3444bd31a48ff7373efc791412ef110b from "./generated-4c96dbed-66b2-4b77-a4e9-26079d627fb7.json";

import a07e35ba790a8baf05a3daa36de7f7881b from "./generated-9a90d33a-efbb-46d6-af04-3a8a9b0db86a.json";

import a84fc16cc985cc729f709c62fd5b2ae9eb from "./generated-b1cc59e2-2aec-4911-bf36-aba221c47496.json";

import ac7ff3ed184f4367efca82bcf764a7879b from "./generated-8f1ee6dd-8dd2-4a31-8b4c-883ee8f361f6.json";

import ad1539acb6fe35464376f2cae84e93523b from "./generated-f1c11196-da22-456e-ada8-714031783a7a.json";

import aae06e55ba5d42b6a278936edb51248f0b from "./generated-70556e3b-460c-4ba7-805e-70a9e10cc16c.json";

import ac3f98b01f9322f570957f6e58e305276b from "./generated-7e4817a3-e1b3-4fe6-a6b8-d4be6f369640.json";

import a6619852d7fe4611dca58857eb3a7805bb from "./generated-0b4ea110-6bca-4881-8910-e870e833d36b.json";

import ae7b6480df6af664a9cfd024727a349e9b from "./generated-a9c5bced-5aba-482a-b273-80fe06338bf0.json";

import a101a951e06116906556b0ec5211aca89b from "./generated-11f1fcb6-ccbb-491c-9622-01ba5692e702.json";

import a089b78187d9e08afeb975cd0a736d116b from "./generated-0e9e6675-d025-416f-91c4-ee145adacb8d.json";

import ad2e2af1ea6c6663d5a4a78fb9e2a7b7cb from "./generated-411ed9f2-edb7-463b-814c-de210d5ebe9c.json";

import a08d4ddce9e5cfb37b8de7e9f2549d3fbb from "./generated-e7a5100b-4769-4ad6-ad4c-84d6dc085f08.json";

import a31d9e61af6280b345bca54085bf1800cb from "./generated-656424b3-0a67-4139-948a-d796e6a5d9a0.json";

import a7b6b3db08ffff6b83018a6ae8db05f77b from "./generated-4714faa6-5bc6-4521-b04f-08cbeb3b57d7.json";

import ad84ffd9d7d7be87fbef978f53500e9dab from "./generated-6cc17c55-a484-4fc9-b170-91cf410734b4.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a56313a946694dbccd7bd5340d78e8a9fb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a6528001b924c31c956890512d64f739fb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a4fe25190375de7813e516f4819fb890eb);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(af3444bd31a48ff7373efc791412ef110b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a07e35ba790a8baf05a3daa36de7f7881b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a84fc16cc985cc729f709c62fd5b2ae9eb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ac7ff3ed184f4367efca82bcf764a7879b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ad1539acb6fe35464376f2cae84e93523b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(aae06e55ba5d42b6a278936edb51248f0b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(ac3f98b01f9322f570957f6e58e305276b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a6619852d7fe4611dca58857eb3a7805bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ae7b6480df6af664a9cfd024727a349e9b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a101a951e06116906556b0ec5211aca89b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a089b78187d9e08afeb975cd0a736d116b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(ad2e2af1ea6c6663d5a4a78fb9e2a7b7cb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a08d4ddce9e5cfb37b8de7e9f2549d3fbb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a31d9e61af6280b345bca54085bf1800cb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a7b6b3db08ffff6b83018a6ae8db05f77b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ad84ffd9d7d7be87fbef978f53500e9dab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a31d9e61af6280b345bca54085bf1800cb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */